import { render } from "./TenderDetail.vue?vue&type=template&id=5b5f40b0&scoped=true"
import script from "./TenderDetail.vue?vue&type=script&lang=js"
export * from "./TenderDetail.vue?vue&type=script&lang=js"

import "./TenderDetail.vue?vue&type=style&index=0&id=5b5f40b0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5b5f40b0"

export default script